module.exports = __webpack_public_path__ + "media/images/hitfun3/icon.prize.default-6ba087a2beadb95ee4a6f393effa2a86.svg";